import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Layout from '../components/Layout';

interface Props {
  lang: 'en' | 'ru' | 'it' | 'fr';
}

export default function About({ lang }: Props) {
  const { t } = useTranslation('about');
  const tc = useTranslation('common').t;
  const list = t('list', { returnObjects: true }) as string[];

  return (
    <Layout lang={lang}>
      <div className="blog-post">
        <h2 className="blog-post-title">{t('title')}</h2>
        <p className="blog-post-meta">
          {t('date')} &nbsp;|&nbsp; <Link to={lang === 'en' ? '/' : `/${lang}`}>{tc('mainPage')}</Link>
          &nbsp;|&nbsp; <a href="https://github.com/microbusiness" target="_blank" rel="noopener noreferrer">{tc('github')}</a>
        </p>
        <hr />

        <p>{t('p1')}</p>
        <p>{t('p2')}</p>

        <blockquote className="blockquote border-left pl-3">
          <p className="mb-0">{t('quote1')}</p>
        </blockquote>

        <blockquote className="blockquote border-left pl-3">
          <p className="mb-0">{t('quote2')}</p>
        </blockquote>

        <blockquote className="blockquote border-left pl-3">
          <p className="mb-0">{t('quote3')}</p>
        </blockquote>

        <hr />
        <h4>{t('shortlyTitle')}</h4>
        <ul>
          {list.map((item, i) => (
            <li key={i}>{item}</li>
          ))}
        </ul>

        <p><em>"{t('quote4')}"</em></p>
      </div>
    </Layout>
  );
}
